(function () {
  class FreeSpinsOutro extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);
    }

    initialise() {
      this._jsonPath = this.name + ':freeSpinsOutroContainer';
      this._outroPanel = undefined;
      this._panelMask = undefined;
      this._skipButton = undefined;
      this._cashWonText = undefined;
      this._touchToContinue = undefined;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
    }

    onGameConfigEvent(task) {
      this._outroPanel = resourceManager.get(this._jsonPath + ':outroPanel:frame');
      this._outroPanel.visible = false;

      this._panelMask = resourceManager.get(this._jsonPath + ':panelMask');
      this._panelMask.visible = false;

      this._skipButton = resourceManager.get(this._jsonPath + ':panelMask:skipButton');
      this._skipButton.interactive = false;
      this._skipButton.mousedown = this._skipButton.touchstart = this.skipPressed.bind(this);

      this._cashWonText = resourceManager.get(this._jsonPath + ':outroPanel:frame:cashWon');
      this._congratsText = resourceManager.get(this._jsonPath + ':outroPanel:frame:congratsText');
      this._youWonText1 = resourceManager.get(this._jsonPath + ':outroPanel:frame:youWonText1');
      this._youWonText2 = resourceManager.get(this._jsonPath + ':outroPanel:frame:youWonText2');

      this._touchToContinue = resourceManager.get(this._jsonPath + ':outroPanel:frame:touchToContinue');
      const isMobile = gdk.deviceInfo.mobile;

      if (isMobile) {
        this._touchToContinue.setTranslationPhrase('t_gcTouchAnywhere');
      } else {
        this._touchToContinue.setTranslationPhrase('t_splashContinue');
      }
    }

    congratsAllowed(winnings, stake) {
      let result = false;
      if (winnings > stake) {
        result = true;
      }
      return result;
    }

    startOutro(callback, winnings) {
      this._touchToContinue.visible = false;

      musicManager.onFreespinsOutro();

      // are we allowed to show congrats panel?
      // what if we have won nothing?
      const stake = gameController.globalHelperGetStake();
      const showCongrats = this.congratsAllowed(winnings, stake);

      if (!showCongrats) {
        this._congratsText.renderable = false;
        this._youWonText1.renderable = false;
        this._youWonText2.renderable = true;
      } else {
        this._congratsText.renderable = true;
        this._youWonText1.renderable = true;
        this._youWonText2.renderable = false;
      }

      this._completeCallback = callback;

      this._outroPanel.scale.set(0);
      this._outroPanel.visible = true;

      this._panelMask.alpha = 0;
      this._panelMask.visible = true;

      const value = gdk.formatCurrency(winnings, false);
      this._cashWonText.setText(value);

      gsap.to(this._outroPanel.scale, {
        duration: 0.5,
        x: 1,
        y: 1,
        ease: 'power1.inOut',
        onComplete: () => {
          this._outroPanel.scale.set(1);
          this._touchToContinue.visible = true;
          this._skipButton.interactive = true;
          game.autoClickForReplayRewatch(() => {
            this.skipPressed();
          });
        },
      });

      gsap.to(this._panelMask, {
        duration: 0.5,
        alpha: 1,
        ease: 'none',
        onComplete: () => {
          this._panelMask.alpha = 1;
        },
      });
    }

    endOutro() {
      if (musicManager.fsOutroTimer != null) {
        timerManager.stop(musicManager.fsOutroTimer);
        musicManager.fsOutroTimer = null;
        musicManager.onFreeSpinsEnd();
      }

      gsap.to(this._outroPanel.scale, {
        duration: 0.5,
        x: 0,
        y: 0,
        ease: 'power1.inOut',
        onComplete: () => {
          this._outroPanel.visible = false;
          this._outroPanel.scale.set(1);
          this._completeCallback();
        },
      });

      resourceManager.get('gameBackground:GameBackground').setHueToPerc(0);

      gsap.to(this._panelMask, {
        duration: 0.5,
        alpha: 0,
        ease: 'none',
        onComplete: () => {
          this._panelMask.visible = false;
          this._panelMask.alpha = 1;
        },
      });

      // re-show the golden bet button
      resourceManager.get('backgroundButtons:luckyBetToggleButton').visible = true;
    }

    skipPressed() {
      game.stopAutoClickForReplayRewatch();
      if (gameController.bonusTriggeringReels.length) {
        gameController.swapToPreBonusReels();
      }

      this._touchToContinue.visible = false;
      this._skipButton.interactive = false;
      this.endOutro();
    }
  }

  create = function (json) {
    return new FreeSpinsOutro();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('freeSpinsOutro', create, initialise, getFilesRequired);
})();
